module.exports = __webpack_public_path__ + "img/nopro.99a0fa2f.png";